import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CreateTask from '../../components/modal/CreateTask';
import { triggerTaskCreation, triggerAutoUploadAndTaskCreation } from '../../actions/records';
import { getEmaTaskProviders, getKareoTaskProviders, getTaskTemplatesByQuery } from '../../actions/userProfile';

class CreateTaskDialog extends Component {
  static propTypes = {
    editReceivedRecordLabels: PropTypes.func.isRequired,
  }

  render() {
    return (
      <div>
        <CreateTask
          {...this.props}
        />
      </div>
    );
  }
}

CreateTaskDialog.propTypes = {
  triggerTaskCreation: PropTypes.func.isRequired,
};


export default connect(state => ({
  sendToken: state.auth.data.sendToken,
  allEmaTaskProviders: state.userProfile.allEmaTaskProviders,
  allKareoTaskProviders: state.userProfile.allKareoTaskProviders,
}), { triggerTaskCreation, triggerAutoUploadAndTaskCreation, getEmaTaskProviders, getKareoTaskProviders, getTaskTemplatesByQuery })(CreateTaskDialog);
